import Vue from "vue";
import App from "./App.vue";
import VueGtag from "vue-gtag";
import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faSync,
  faUser,
  faEnvelope,
  faBuilding,
  faPhone,
  faKey,
  faBookReader,
  faDatabase,
  faTable,
  faUserClock,
  faChartArea,
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import "../src/main.sass";

import router from "./router";
import store from "./store";

library.add(
  faSync,
  faUser,
  faEnvelope,
  faBuilding,
  faPhone,
  faKey,
  faBookReader,
  faDatabase,
  faTable,
  faUserClock,
  faChartArea
);

Vue.config.productionTip = false;
Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(
  VueGtag,
  {
    config: { id: "UA-119331214-4" },
    enabled: process.env.NODE_ENV === "production",
  },

  router
);

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
